import { Badge, Box, SpaceBetween } from '@cloudscape-design/components';
import { PlaceType } from '../common/types';
import { useMemo } from 'react';

export const IGNORE_TYPES = ['establishment', 'colloquial_area', 'point_of_interest'];

export type PlaceTypeListProps = {
  types: PlaceType[];
};

export function PlaceTypeList(props: PlaceTypeListProps) {
  return (
    <SpaceBetween direction="horizontal" size="xxs">
      {props.types
        .filter((type) => !IGNORE_TYPES.includes(type.name))
        .map((type) => (
          <PlaceTypeBadge key={type.uuid} type={type} />
        ))}
    </SpaceBetween>
  );
}

export type PlaceTypeBadgeProps = {
  type: PlaceType;
};

export function PlaceTypeBadge(props: PlaceTypeBadgeProps) {
  const name = useMemo(() => {
    const fixedName = props.type.name.replaceAll('_', ' ');
    return fixedName
      .split(' ')
      .map((word) => (word.length > 2 ? word.charAt(0).toUpperCase() + word.slice(1) : word))
      .join(' ');
  }, [props.type.name]);
  return (
    <Badge key={props.type.uuid} color="severity-neutral">
      {name}
    </Badge>
  );
}
